
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 49 49"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#4285F4","d":"M46.477 24.147c0-1.56-.14-3.06-.4-4.5h-20.72v8.52h11.84c-.52 2.74-2.08 5.06-4.42 6.62v5.54h7.14c4.16-3.84 6.56-9.48 6.56-16.18"}}),_c('path',{attrs:{"fill":"#34A853","d":"M25.357 45.647c5.94 0 10.92-1.96 14.56-5.32l-7.14-5.54c-1.96 1.32-4.46 2.12-7.42 2.12-5.72 0-10.58-3.86-12.32-9.06h-7.32v5.68c3.62 7.18 11.04 12.12 19.64 12.12"}}),_c('path',{attrs:{"fill":"#FBBC05","d":"M13.037 27.827c-.44-1.32-.7-2.72-.7-4.18s.26-2.86.7-4.18v-5.68h-7.32c-1.5 2.96-2.36 6.3-2.36 9.86s.86 6.9 2.36 9.86l5.7-4.44z"}}),_c('path',{attrs:{"fill":"#EA4335","d":"M25.357 10.407c3.24 0 6.12 1.12 8.42 3.28l6.3-6.3c-3.82-3.56-8.78-5.74-14.72-5.74-8.6 0-16.02 4.94-19.64 12.14l7.32 5.68c1.74-5.2 6.6-9.06 12.32-9.06"}})])
          )
        }
      }
    